import React from "react";
import PropTypes from "prop-types";
import CloseLink from "components/v3/close-link/CloseLink";
import Helmet from "react-helmet";
import styles from "./styles.module.scss";

const ModalHeader = ({ title, closeable, children }) => {
    return (
        <div className={ styles.header }>
            <Helmet title={ `${ title } - Bloomberg` } />
            <h1 className={ styles.title }>{ title }</h1>
            { children }
            { closeable ? <CloseLink /> : null }
        </div>
    );
};

ModalHeader.propTypes = {
    title: PropTypes.string,
    closeable: PropTypes.bool
};

ModalHeader.defaultProps = {
    closeable: true
};

export default ModalHeader;
